
class VillaLists {
  constructor(el) {
    if(!el) return false;
    this.el = el;
    this.tabs = this.el.querySelectorAll('[data-villa-lists-tab]');
    this.contents = this.el.querySelectorAll('[data-villa-lists-content]');
    this.state = {};
    this.inTransition = false;
    this.pageSlug = document.querySelector('body').getAttribute('data-page');

    if (!this.el.querySelector('[data-villa-lists-tab].active')) {
      this.tabs[0].classList.add('active');
    }
    this.el.classList.add('tabbed');

    Array.from(this.tabs).forEach((tab) => {
      tab.addEventListener('click', this.clickHandler.bind(this))
    })
    window.onpopstate = this.syncState.bind(this);
    this.initState();
  }
  initState() {
    this.state.tabs = {
      current: Array.from(this.tabs).find((tab) => tab.classList.contains('active')),
      next: Array.from(this.tabs).find((tab) => !tab.classList.contains('active'))
    }
    this.state.path = `${window.location.pathname.split(this.pageSlug)[0]}${this.pageSlug}/`;
    this.state.style = this.state.tabs.current.getAttribute('data-style');

    window.history.replaceState({ page: 'villas', style: this.state.style }, '', `${this.state.path}${this.state.style}`);
  }
  setState(style) {
    this.state.style = style;
    window.history.pushState({ page: 'villas', style: this.state.style }, '', `${this.state.path}${this.state.style}`);
    this.updateView();
  }
  syncState() {
    if (this.state.tabs.current.getAttribute('data-style') !== window.history.state.style) {
      this.state.style = window.history.state.style;
      this.updateView();
    }
  }
  syncTabState() {
    this.state.tabs = {
      current: Array.from(this.tabs).filter((tab) => tab.classList.contains('active'))[0],
      next: Array.from(this.tabs).filter((tab) => !tab.classList.contains('active'))[0]
    }
  }
  clickHandler() {
    if(event.target.classList.contains('active')) return;
    this.setState(event.target.getAttribute('data-style'));
  }
  updateView() {
    if (this.inTransition) return;
    if (this.state.tabs.current.getAttribute('data-style') === this.state.style) return;
    this.inTransition = true;
    step1.bind(this)();


    function step1() {
      let step1done = false;
      function step1complete(event) {
        if(event.target === this.state.tabs.next && event.propertyName == 'transform' && step1done === false) {
          step1done = true;
          this.state.tabs.next.removeEventListener('transitionend', step1complete.bind(this));
          step2.bind(this)();
        }
      }
      this.state.tabs.next.addEventListener('transitionend', step1complete.bind(this));
      this.el.classList.add('in-transition', 'step1');
    };
    function step2() {
      let step2done = false;
      function step2complete(event) {
        if(event.target === this.state.tabs.current && event.propertyName == 'transform' && step2done === false) {
          step2done = true;
          this.state.tabs.current.removeEventListener('transitionend', step2complete.bind(this));
          final.bind(this)();
        }
      }
      this.state.tabs.current.addEventListener('transitionend', step2complete.bind(this));
      this.el.classList.add('step2');
    }
    function final() {
      this.state.tabs.next.classList.add('active');
      this.state.tabs.current.classList.remove('active');
      this.el.classList.remove('in-transition', 'step1', 'step2');
      this.syncTabState();
      this.state.tabs.next.addEventListener('animationend', () => {
        this.inTransition = false;
        this.syncState();
      }, {once: true});
    }
  }
}

export default function () {
  const Lists = new VillaLists(document.querySelector('[data-villa-lists]'));
}



// WEBPACK FOOTER //
// ./public/javascripts/modules/villas.js